import { cn } from '@repo/tailwind-config/tailwind.functions'
import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import Badge from '@repo/ui/badge'
import LinkFile from '@repo/ui/link-file'
import Typography from '@repo/ui/typography'

import { eventActionTypeEnumMapping } from '../../../lib/types/enums/center-event-action/event-action-type.enum'
import { CenterEventProperties } from '../../../lib/types/models/center-event/properties.center-event'
import { CenterEventAction } from '../../../lib/types/models/center-event-action/center-event-action'

type Props = {
  mode: 'view' | 'item'
  action: CenterEventAction
  className?: string
  onClick?: () => void
}

const CenterEventActionItem = ({ action, mode, className, onClick }: Props) => {
  const creationData = CenterEventProperties.getActionCreationInformation(action)
  return (
    <div
      className={cn(
        'flex flex-col gap-1 py-2 border-t border-t-grey-light first:border-t-0 ',
        { 'cursor-pointer': !!onClick, 'gap-2': mode === 'view' },
        className
      )}
      onClick={onClick}
    >
      {mode === 'view' ? (
        <Badge text={creationData} variant={'primary'} />
      ) : (
        <Typography variant="label-semibold" color={tailwindColors.primary.DEFAULT}>
          {creationData}
        </Typography>
      )}
      <Typography variant="secondary-body">
        {`${eventActionTypeEnumMapping[action.actionType]} : ${action.name}`}
      </Typography>
      <Typography variant="secondary-body" className={cn('w-full', { truncate: mode === 'item' })}>
        {action.description}
      </Typography>
      <div className={cn('flex gap-2 items-center', { 'flex-col items-start': mode === 'view' })}>
        {action.files.map((file) => (
          <LinkFile key={file.id} file={file} />
        ))}
      </div>
    </div>
  )
}

export default CenterEventActionItem
